import React from 'react';
import { Icon as CrateIcon } from '@tcc/crate';
import styles from '../RegionReport.css';
import { LocalizedMeasurementQU, YieldRegionReport} from '../../../../types';
import { getLocalizedArea, getLocalizedAverageYield } from '../frrStatsFormat';

export type RegionReportItemsLabelProps = {
  dataTestId: string;
  showIcon: boolean;
  index: number;
  area: YieldRegionReport['area'];
  averageYield: YieldRegionReport['averageYield'];
  cropCode: string;
  cropNominalWeight?: number
};

export const RegionReportItemsLabel = ({
  averageYield,
  area,
  dataTestId,
  showIcon,
  cropCode,
  cropNominalWeight
}: RegionReportItemsLabelProps) => {
  const localizedArea: LocalizedMeasurementQU = getLocalizedArea(area);
  const averageYieldLocalized = getLocalizedAverageYield(cropCode, averageYield, cropNominalWeight);

  return (
    <>
      <div data-test-id={`dmb-region-report-${dataTestId}-areaq`}>
        {localizedArea.q}
      </div><div className={styles.last}>
        <div data-test-id={`dmb-region-report-${dataTestId}-yieldq`}>
        { averageYieldLocalized ? averageYieldLocalized.q : '-'}
        </div>
        <div>
          {showIcon &&
            <CrateIcon
              testId={`dmb-region-report-${dataTestId}-icon`}
              glyph={CrateIcon.set.ARROW_RIGHT}
            />}
        </div>
      </div>
    </>
  );
};